import { FONT, FontStyleSheet } from '../font-style-sheets';
import { PrintLabelMenu } from './print-label-menu';

export class BaseInventoryPrintLabelMenu extends PrintLabelMenu {
  whatFontsAreNeededToRenderContent(): FontStyleSheet[] {
    return [FONT.Poppins.Bold_700, FONT.Poppins.Medium_500];
  }

  /**
   * All fonts are sourced from the assets folder
   */
  override getAdobeFontFamilyCssUrl(): string | null {
    return null;
  }

  shouldStandardizeDominantStrainType(): boolean {
    return false;
  }
}
